exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#DyQuillEditor[data-v-4b8f5140]{\n  width:100%\n}\n#DyQuillEditor[data-v-4b8f5140]  .ql-editor{\n  min-height:240px\n}\n#DyQuillEditor .avatarUploader[data-v-4b8f5140]{\n  display:none\n}", ""]);

// exports
